export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDOfXqK5DWhT7sjlzLqwS2C21xr-uz7uNQ',
    authDomain: 'aleksilahti-portfolio.firebaseapp.com',
    projectId: 'aleksilahti-portfolio',
    messagingSenderId: '764685405504',
    appId: '1:764685405504:web:ec27b4859b0a77392f3ea5'
  },
  adminEmails: ['aleksi.mikael.lahti@gmail.com'],
  contactEmail: 'aleksi.mikael.lahti@gmail.com',
  linkedInProfileUrl: 'https://www.linkedin.com/in/aleksimikaellahti/',
  contactAvatarUrl: '/assets/imagebucket/profile.png',
  siteOwnerName: 'Aleksi Lahti'
};
